import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Token } from "../../../../../Script/Session";
import { post} from "../../../../../Script/Session";
import "./Groupediting.css";
import Stylebutton from "../../../../../components/buttons/stylebutton/Stylebutton";
import FancyCheckbox from "../../../../../components/Checkbox/FancyCheckbox";
const Groupediting = ({setfilterdata,filterdata, groups, id, setmask, item}) => {

    useEffect(() => {
 
    
    
    
    
    
    
    
    
    });
    


    function save() {
        let body = {
            token: Token.get(),
            action: "setgroups",
            target: id + "",
        }
        let list = Object.keys(checkboxes).filter(name => checkboxes[name]);
        body.groups = list;
        console.log(body);
        let response = post(body, "/usermanagement");
        console.log(response);
        if (response == "OK") {
            alert("Gruppen erfolgreich gesetzt");
            let update = filterdata.map(s => s.id === id ? {... s, groups:  Object.keys(checkboxes)
                .filter(name => checkboxes[name])
                .map(name => ({ name }))} : s);
            setfilterdata(update);
            setmask(false);
        }
    }
    const [checkboxes, setCheckboxes] = useState({});
    useEffect(() => {
        const initialCheckboxes = groups.reduce((acc, g) => {
          acc[g.name] = item.groups.some(i => i.name === g.name);
          return acc;
        }, {});
        setCheckboxes(initialCheckboxes);
      }, [item, groups]);
    const handleCheckboxChange = (name) => {
        console.log(name);
        setCheckboxes((prevCheckboxes) => ({
          ...prevCheckboxes,
          [name]: !prevCheckboxes[name], // Status der Checkbox umkehren
        }));
      };
    return (
        <div style={{position: "absolute", left: "50%", top: "50%",transform: "translate(-50%, -50%)", backgroundColor: "white", display: "flex",
        width: "50%",
        height: "60%",
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        flexDirection: "column",
        alignItems: "center"
        }}>
        <div style={{height: "10%", width: "100%", backgroundColor: "#2b3142", alignItems: "center", justifyContent: "center", display: "flex",fontSize: "20px"}}>
            <p>Funktionen von {item.name}</p>
        </div>


        <div style={{
                        backgroundColor:"transparent",
                        width: "98%",
                        borderStyle: "solid",
                        borderColor: "black",
                        borderWidth: "1px",
                        borderColor: "lightgray",
                        marginTop: "35px"
                    }}>
                       <div style={{
                            width: "100%",
                            height: "40px",
                            backgroundColor: "white",
                            display: "flex",
                            color: "black",
                            fontSize: "15px",
                            alignItems: "center",
                            fontWeight: "bold",
                            borderBottom: "1px solid darkgray",
                       }}>
                        <p style={{marginLeft: "1.5%"}}>Gruppen:</p>

                       </div>
                <ul style={{backgroundColor: "transparent",height: "400px", width: "100%", overflowY: "auto"}}>
                    {groups.map((item, index) => (
                        <li>
                            <div style={{backgroundColor: "transparent", height: "60px", width: "100%", display: "flex", flexDirection: "row", alignItems: "center", color:"gray"}}>
                                <div style={{marginLeft: "1.5%"}}><FancyCheckbox checked={checkboxes[item.name]} onChange={handleCheckboxChange} name={item.name} index={index}/></div>
                                <p style={{marginTop: "1.3%"}}>{item.name}</p>
                            </div>
                        </li>



                    ))}



                </ul>
                
            </div>
            <div style={{flexDirection: "row", marginTop: "10px", width: "100%", justifyContent: "space-evenly", display: "flex"}}>
                <div onClick={() => setmask(false)}><Stylebutton buttonText={"Abbrechen"} width={"150px"} /></div>
                <div onClick={() => {save()}}><Stylebutton buttonText={"Speichern"}  width={"150px"} /></div>
            </div>

        </div>  
    );




}
export default Groupediting;